<div *ngIf="poster">
  <h2>{{ 'Produkt' | translate }}</h2>
  <mat-tab-group>
    <mat-tab [label]="'Info' | translate" #infoTab>
      <br />
      <div class="row">
        <div class="col">
          <h6>{{ 'Namn' | translate }}</h6>
          <h5>{{poster.name}}</h5>
        </div>
        <div class="col">
          <h6>SKU</h6>
          <h5>{{poster.sku}}</h5>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="'Generellt' | translate" #generalTab *ngIf="globals.userIsAce()">
      <br />

      <div class="row">
        <div class="col-6">
          <div *ngIf="poster.metadata?.generateThumbnailsInBackground && !poster.thumbnail">
            <h3 class="align-center">{{ 'Tumnagel skapas i bakgrunden..' | translate }}</h3>
            <br />
            <br />
          </div>
          <div *ngIf="thumbnailUrl">
            <img [src]="thumbnailUrl" class="thumbnail" />
          </div>
          <div *ngIf="!thumbnailUrl">
            <file-uploader [uploadUrl]="'/posters/' + poster._id + '/thumbnail'" [customText]="'Släpp tumnagelbild här' | translate"
              (fileUploaded)="refresh()"></file-uploader>
          </div>

          <!-- Generated extras: the passepartout mount and any interior mockups.
               Both are published as Shopify product images, so seeing them here
               is the only way to check them without opening Shopify. -->
          <div class="additional-images" *ngIf="passepartoutThumbnailUrl || mockupImages.length">
            <div class="additional-image" *ngIf="passepartoutThumbnailUrl">
              <h6>{{ 'Passepartout' | translate }}</h6>
              <a [href]="passepartoutThumbnailUrl" target="_blank">
                <img [src]="passepartoutThumbnailUrl" class="thumbnail" />
              </a>
            </div>

            <div class="additional-image" *ngFor="let mockup of mockupImages">
              <h6>{{ mockup.label | translate }}</h6>
              <a [href]="mockup.url" target="_blank">
                <img [src]="mockup.url" class="thumbnail" />
              </a>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-6">
              <mat-form-field class="fullwidth">
                <label>{{ 'Namn' | translate }}</label>
                <input matInput [(ngModel)]="poster.name">
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field class="fullwidth">
                <label>SKU</label>
                <input matInput [(ngModel)]="poster.sku">
              </mat-form-field>
            </div>
          </div>

          <br />
          <mat-form-field class="fullwidth">
            <label>{{ 'Beskrivning' | translate }}</label>
            <textarea matInput [(ngModel)]="poster.description"></textarea>
          </mat-form-field>

          <br />

          <h4>{{ 'Generera beskrivning' | translate }}</h4>
          <mat-tab-group>
            <mat-tab [label]="'Från prompt' | translate">
              <br />
              <div class="row">
                <div class="col">
                  <mat-form-field class="fullwidth">
                    <label>{{ 'Prompt' | translate }}</label>
                    <input matInput [(ngModel)]="prompt" />
                  </mat-form-field>
                  <button mat-raised-button color="primary" [disabled]="generatingDescription" class="fullwidth"
                    (click)="generateDescription()">{{ 'Generera' | translate }}</button>
                </div>
              </div>
            </mat-tab>
            <mat-tab [label]="'Auto' | translate">
              <br />
              <button mat-raised-button color="primary" class="fullwidth" [disabled]="generatingDescription"
                (click)="autoGenerateDescription()">{{ 'Autogenerera' | translate }}</button>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <h3>{{ 'Priser' | translate }}</h3>
          <size-price-editor [prices]="poster.sizePrices"></size-price-editor>
        </div>
      </div>

      <div class="row">
        <div class="col-12 align-right">
          <br />
          <button mat-raised-button color="primary" (click)="save()">{{ 'Spara' | translate }}</button>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="'Barcodes' | translate" #barcodeTab>
      <br />
      <div class="row">
        <div class="col-12">
          <barcode-generator preSelectedType="007" [simpleSizeSelector]="true"
            (barcodeChanged)="barcodeChanged($event)"></barcode-generator>
          <div class="align-center">
            <h3>{{ 'SKU:' | translate }}</h3>
            <h1>{{sku}}</h1>
          </div>
        </div>
      </div>
    </mat-tab>


    <mat-tab [label]="'Tryckfiler' | translate" #printFilesTab>
      <br />
      <div *ngIf="missingSizes">
        <div class="row">
          <div class="col-12 align-right" *ngIf="poster.originalFileUrl">
            <a href="{{poster.originalFileUrl}}" target="_blank">{{ 'Originalfil' | translate }}</a>
          </div>
          <div class="col-12">
            <h3>{{ 'Ladda upp tryckfil' | translate }}</h3>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="fullwidth">
              <mat-label>{{ 'Storlek' | translate }}</mat-label>
              <mat-select [(ngModel)]="selectedSize">
                <mat-option *ngFor="let size of missingSizes[selectedType]" [value]="size">{{size}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="fullwidth">
              <input matInput [(ngModel)]="selectedSize" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="fullwidth">
              <mat-label>{{ 'Typ' | translate }}</mat-label>
              <mat-select [(ngModel)]="selectedType">
                <mat-option [value]="'POSTER'">{{ 'Poster' | translate }}</mat-option>
                <mat-option [value]="'CANVAS'">{{ 'Canvas' | translate }}</mat-option>
                <mat-option [value]="'TSHIRT'">{{ 'T-Shirt' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12">
            <google-cloud-uploader *ngIf="selectedSize" [posterId]="poster._id" [printFileSize]="selectedSize"
              [posterType]="selectedType" (fileUploaded)="printFileUploaded($event)"></google-cloud-uploader>
          </div>
          <!--  <div class="col-6" *ngIf="selectedSize">
            <button mat-raised-button color="primary" [disabled]="generatingPrintFile" (click)="generatePrintFile()">{{ 'Generera från originalfil' | translate }}</button>
          </div> -->
        </div>


        <br />
        <hr />
        <br />
      </div>

      <div class="previews">
        <div class="row" *ngIf="printFilePreviews['POSTER']">
          <div class="col-12">
            <h3>{{ 'Tryckfiler (Poster)' | translate }}</h3>
          </div>
          <div class="col-6" *ngFor="let preview of printFilePreviews['POSTER']">
            <h4 class="align-center">{{preview.size}}</h4>
            <h5 class="align-center" *ngIf="preview.printFile.approvedByHuman">{{ '(Godkänd av en människa)' | translate }}</h5>
            <iframe [src]="preview.url"></iframe>
            <br />
            <br />
          </div>
        </div>

        <div class="row" *ngIf="printFilePreviews['CANVAS']">
          <div class="col-12">
            <h3>{{ 'Tryckfiler (Canvas)' | translate }}</h3>
          </div>
          <div class="col-6" *ngFor="let preview of printFilePreviews['CANVAS']">
            <h4 class="align-center">{{preview.size}}</h4>
            <h5 class="align-center" *ngIf="preview.printFile.approvedByHuman">{{ '(Godkänd av en människa)' | translate }}</h5>
            <iframe [src]="preview.url"></iframe>
            <br />
            <br />
          </div>
        </div>

        <div class="row" *ngIf="printFilePreviews['TSHIRT']">
          <div class="col-12">
            <h3>{{ 'Tryckfiler (T-Shirt)' | translate }}</h3>
          </div>
          <div class="col-6" *ngFor="let preview of printFilePreviews['TSHIRT']">
            <h4 class="align-center" *ngIf="preview.size">{{preview.size}}</h4>
            <h5 class="align-center" *ngIf="preview.printFile.approvedByHuman">{{ '(Godkänd av en människa)' | translate }}</h5>
            <div class="align-center">
              <img [src]="preview.printFile.url" />
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>

    </mat-tab>

    <mat-tab label="Shopify" class="partner-store-admin-color"
      *ngIf="globals.userIsAce() && globals.storeSettings && globals.storeSettings.shopifySettings" #shopifyTab>
      <br />
      <div *ngIf="poster.thirdParty && poster.thirdParty.shopify && poster.thirdParty.shopify.productId">
        <h3>{{ 'Kopplad till produkt' | translate }} {{poster.thirdParty.shopify.productId}} {{ 'i Shopify' | translate }}</h3>

        <p *ngIf="loadingShopifyProduct">{{ 'Hämtar produktinformation…' | translate }}</p>

        <p *ngIf="shopifyProduct && shopifyProduct.missing" class="shopify-product-missing">
          {{ 'Produkten kunde inte hämtas från Shopify. Den kan ha raderats där.' | translate }}
        </p>

        <table class="styled compact shopify-product-info" *ngIf="shopifyProduct && !shopifyProduct.missing">
          <tr>
            <th>{{ 'Titel' | translate }}</th>
            <td>{{ shopifyProduct.title }}</td>
          </tr>
          <tr>
            <th>{{ 'Produkttyp' | translate }}</th>
            <td>{{ shopifyProduct.productType }}</td>
          </tr>
          <tr>
            <th>{{ 'Status' | translate }}</th>
            <td>{{ shopifyProduct.status }}</td>
          </tr>
          <tr>
            <th>{{ 'Varianter' | translate }}</th>
            <td>{{ shopifyProduct.variantCount }}</td>
          </tr>
          <tr *ngIf="shopifyProduct.tags">
            <th>{{ 'Taggar' | translate }}</th>
            <td>{{ shopifyProduct.tags }}</td>
          </tr>
          <tr>
            <th>{{ 'Produkt-ID' | translate }}</th>
            <td>{{ shopifyProduct.productId }}</td>
          </tr>
        </table>
        <br />

        <a [href]="shopifyProductAdminUrl()" target="_blank">
          <button mat-raised-button color="primary">{{ 'Visa Shopify-produkt' | translate }}</button>
        </a>
        &nbsp;
        <button mat-raised-button color="primary" (click)="deleteShopifyProduct()">{{ 'Radera Shopify-produkt' | translate }}</button>
      </div>

      <div *ngIf="!poster.thirdParty || !poster.thirdParty.shopify || !poster.thirdParty.shopify.productId">
        <div class="row">
          <div class="col">
            <h5>{{ 'Poster' | translate }}</h5>
            <div *ngFor="let size of availablePosterSizes">
              <mat-checkbox [(ngModel)]="shopifySizesToCreate.poster[size]">
                {{size}}
              </mat-checkbox>
            </div>
          </div>
          <div class="col">
            <h5>{{ 'Canvas' | translate }}</h5>
            <div *ngFor="let size of availableCanvasSizes">
              <mat-checkbox [(ngModel)]="shopifySizesToCreate.canvas[size]">
                {{size}}
              </mat-checkbox>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col">
            <div class="shopify-sku-preview">
              {{ 'Varianterna skapas utan streckkod, med SKU enligt formatet:' | translate }}
              <br />
              <b>{{ shopifySkuPreview() }}</b>
              <br />
              <span class="small-text" *ngIf="!poster.sku">
                {{ 'SKU saknas och skapas automatiskt från namnet.' | translate }}
              </span>
            </div>
            <br />
            <button mat-raised-button color="primary" (click)="createShopifyProduct()">{{ 'Skapa Shopify-produkt' | translate }}</button>
          </div>
        </div>
      </div>

    </mat-tab>

    <mat-tab label="WooCommerce" *ngIf="globals.userIsAce() && globals.storeSettings && globals.storeSettings.woocommerceSettings"
      #woocommerceTab>
      <br />
      <div *ngIf="poster.thirdParty && poster.thirdParty.wooCommerce && poster.thirdParty.wooCommerce.productId">
        <h3>{{ 'Kopplad till produkt' | translate }} {{poster.thirdParty.wooCommerce.productId}} {{ 'i WooCommerce' | translate }}</h3>
        <a [href]="globals.storeSettings.woocommerceSettings.siteUrl + '/wp-admin/post.php?post=' + poster.thirdParty.wooCommerce.productId + '&action=edit'"
          target="_blank">
          <button mat-raised-button color="primary">{{ 'Visa WooCommerce-produkt' | translate }}</button>
        </a>
        &nbsp;
        <button mat-raised-button color="primary" (click)="deleteWoocommerceProduct()">{{ 'Radera WooCommerce-produkt' | translate }}</button>
      </div>

      <div *ngIf="!poster.thirdParty || !poster.thirdParty.wooCommerce || !poster.thirdParty.wooCommerce.productId">
        <button mat-raised-button color="primary" (click)="createWoocommerceProduct()">{{ 'Skapa WooCommerce-produkt' | translate }}</button>
      </div>

    </mat-tab>
  </mat-tab-group>



</div>
